import React from "react";
import { Link } from 'react-router';
import { whereToShopMenu, servicesMenu, helpCenterMenu, legalMenu } from "../../constants";
import logo from '../../../../assets/images/brand-icon-white.svg';


const MobileHeaderMenu = ({ isShown, login, isAuthenticated, closeMenu }) => {

  const renderRewards = (token, accountNumber, name) =>{
    return (
      isAuthenticated ?
        <li>
          <a href={`https://rewards.shippingcart.com?token=${token}&account_number=${accountNumber}&name=${name}`}>Rewards</a>
        </li>
        :
        <li>
          <a href="https://rewards.shippingcart.com">Rewards</a>
        </li>
    )
  }

  // const handleTrackPackage = () => {
  //   localStorage.setItem("trackPackage", "true");
  // }

  const renderMenu = (header, menu) => {
    return (
      <div style={{ margin: '30px 0px' }}>
        <p style={{ fontWeight: 600, marginBottom: 15 }}>{header}</p>
        <ul className="mobile-list">
          {
            menu.map(({title, url, external}) => (
              !external ?
                <li>
                  <Link to={url} onClick={() => { closeMenu() }}>{title}</Link>
                </li> :
                <li>
                  <a target="_blank" href={url}>{title}</a>
                </li>
            ))
          }
        </ul>
      </div>
    )
  }

  const renderFirstName = () => {
    let firstName = '';
    if (login && login.login.party && login.login.party.first_name) {
      firstName = login.login.party.first_name;
    }
    return firstName;
  }

  const renderOffers = () => {
    return <div style={{ margin: '30px 0px' }}>
      <p style={{ fontWeight: 600, marginBottom: 15 }}>Offers</p>
      <ul className="mobile-list">
        <li>
          <Link to="/promotions">Promos</Link>
        </li>
        {renderRewards(localStorage.jwtToken ? localStorage.jwtToken : null, login && login.login.party ? login.login.party.account_number : null, renderFirstName())}
        <li>
          <Link to="/referral">Referral</Link>
        </li>
      </ul>
    </div>
  }

  return (
    isShown &&
      <div>
        <nav id="fullSidebarNav" className='sidenav open-nav mobile-menu-wrapper' style={{ marginLeft: 0 }}>
          <img alt="logo" src={ logo } />
          <div style={{ marginTop: 40 }}>
            {renderMenu('Where to shop', whereToShopMenu)}
            {renderMenu('Services', servicesMenu)}
            {renderOffers()}
            {renderMenu('Help Center', helpCenterMenu)}
            {renderMenu('Legal', legalMenu)}
          </div>
        </nav>
        <div
          className="overlay-menu"
          data-do="hamburger"
          data-on="click"
          onClick={() => {
            closeMenu();
          }}
          style={{
            opacity: 1,
            zIndex: 999,
          }}>
        </div>
      </div>
  )
}

export default MobileHeaderMenu;


/** WEBPACK FOOTER **
 ** ./src/components/Layout/Header/MobileHeader/MobileHeaderMenu.js
 **/